import dashboardTemplate from './dashboard.html';
import './dashboard.scss';

export default angular
  .module('main.locations.edit.tabs.dashboard', [])

  .directive('editLocationDashboardTab', () => {
    return {
      restrict: 'E',
      template: dashboardTemplate,
      scope: {},
      controller: ($scope,
                   EditLocationDataProvider) => {
        $scope.dataProvider = EditLocationDataProvider.instance;

        angular.extend($scope, {});

        init();

        function init() {

        }
      }
    };
  })
  .name;
